module.exports = __webpack_public_path__ + "img/22.095c38fe.png";